import { Controller, Control } from 'react-hook-form';
import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButton,
} from '@mui/material';

interface ToggleButtonGroupProps {
  buttons: { label: string; value: number | boolean }[];
  name: string;
  control: Control<any>;
  disabled?: boolean;
}

export default function ToggleButtonGroup({
  buttons,
  name,
  control,
  disabled = false,
}: ToggleButtonGroupProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <MuiToggleButtonGroup
          exclusive={true}
          color="primary"
          value={field.value}
          disabled={disabled}
          onChange={(_e, value) => {
            if (value !== null) {
              field.onChange(value);
            }
          }}>
          {buttons.map((button) => (
            <ToggleButton key={'' + button.value} value={button.value}>
              {button.label}
            </ToggleButton>
          ))}
        </MuiToggleButtonGroup>
      )}
    />
  );
}
